module.exports = __webpack_public_path__ + "static/media/logo.2d563f75.png";